"use strict";
exports.__esModule = true;
//# sourceMappingURL=bot-log.type.js.map